/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdetailnodescription3Inputs */

const en_eventdetailnodescription3 = /** @type {(inputs: Eventdetailnodescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No description yet.`)
};

const de_eventdetailnodescription3 = /** @type {(inputs: Eventdetailnodescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Beschreibung.`)
};

/**
* | output |
* | --- |
* | "No description yet." |
*
* @param {Eventdetailnodescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdetailnodescription3 = /** @type {((inputs?: Eventdetailnodescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdetailnodescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdetailnodescription3(inputs)
	return de_eventdetailnodescription3(inputs)
});
export { eventdetailnodescription3 as "eventDetailNoDescription" }